export { navSimulationItems, navHiringItem, navClientsItem, navSecurityItems } from "./navLinks";

export const RISK_ACTIVITY = [
  { code: "Y", label: "Si" },
  { code: "N", label: "No" }
];

export const LABEL_SEX: any = {
  M: "Mujer",
  H: "Hombre"
};

export const LABEL_TYPE_PETS: any = {
  canine: "Perro",
  feline: "Gato"
};

export const YES_NO_CONSTANT = [
  { value: "S", label: "Si" },
  { value: "N", label: "No" },
];
export const SENDA_INFORMADO = [
  { value: "S", label: "Si" },
  { value: "N", label: "No" },
  { value: "IS", label: "Informado (Consultar Senda)" },
]

export const DOC_NUMBER_MAX_LENGTH = 9;
